import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../index.css";
import "./Header.css";
import DarkIcon from "../Media/dark.svg";
import LightIcon from "../Media/light.svg";

function Header() {
  const [mode, setMode] = useState(
    localStorage.getItem("displayMode") || "light",
  );

  useEffect(() => {
    document.body.classList.toggle("dark", mode === "dark");
    document.body.classList.toggle("light", mode === "light");
    localStorage.setItem("displayMode", mode);
  }, [mode]);

  const toggleMode = () => {
    const icon = document.querySelector(".toggle-mode img");
    if (icon) {
      icon.classList.add("fade");
      setTimeout(() => {
        setMode(mode === "light" ? "dark" : "light");
        icon.classList.remove("fade");
      }, 300); // 300ms Fade-Effekt
    } else {
      setMode(mode === "light" ? "dark" : "light");
    }
  };

  return (
    <header>
      <div className="toggle-container">
        <button className="toggle-mode" onClick={toggleMode}>
          {mode === "light" ? (
            <img src={DarkIcon} alt="Dark Mode" />
          ) : (
            <img className="small-icon" src={LightIcon} alt="Light Mode" />
          )}
        </button>
      </div>
      <div className="title">
        <h1>
          <span>Sarahnokumo</span>{" "}
          <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
            Streamplan
          </Link>
        </h1>
        <div className="links">
          <a
            href="https://twitch.tv/sarahnokumo"
            target="_blank"
            rel="noopener noreferrer"
          >
            twitch
          </a>
          <a
            href="https://www.tiktok.com/@sarahnokumo"
            target="_blank"
            rel="noopener noreferrer"
          >
            tiktok
          </a>
          <a
            href="https://instagram.com/sarahnokumo/"
            target="_blank"
            rel="noopener noreferrer"
          >
            instagram
          </a>
          <a
            href="https://youtube.com/@Sarahnokumo"
            target="_blank"
            rel="noopener noreferrer"
          >
            youtube
          </a>
          <a
            href="https://discord.gg/tQ5CwAayPG"
            target="_blank"
            rel="noopener noreferrer"
          >
            discord
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
